/* eslint-disable */
export const handleTitleGenerate = async ({
  e,
  isRegenerate,
  formState,
  setFormState,
  checkError,
  generateTitle,
  titles,
  setTitles,
  setActiveStep,
  handleOpen,
  handleState,
  navigate,
  type,
}) => {
  e.preventDefault();
  setFormState({ ...formState, loading: true });

  try {
    const check = await checkError(formState);
    if (check) {
      setFormState({ ...formState, loading: false });
      return;
    }
    const keywordsArray = formState.keyword
      .split(",")
      .map(kw => kw.trim())
      .filter(Boolean);
    await generateTitle({
      variables: {
        input: {
          count: formState.count,
          keywords: keywordsArray,
          language: formState.language,
        },
      },
      onCompleted: ({ generateKeywordTitle }) => {
        const updatedTitles = isRegenerate ? generateKeywordTitle : [...titles, ...generateKeywordTitle];
        setTitles(updatedTitles);
        setActiveStep(1);
        setFormState({ ...formState, loading: false, selectedTitle: "", isCheckedTitle: true });
        !isRegenerate && navigateToBlog(type, updatedTitles, formState, navigate);
      },
      onError: errdata => {
        handleOpen(true, errdata.message);
        handleState();
      },
    });
  } catch (e) {
    console.log("error", e);
    setFormState({ ...formState, loading: false });
  }
};

// Similarly for handleParagraphGenerate and handleHeadingGenerate
export const handleParagraphGenerate = async ({
  e,
  isRegenerate,
  formState,
  setFormState,
  generateParagraph,
  paragraph,
  titles,
  setParagraph,
  setActiveStep,
  handleOpen,
  navigate,
  type,
}) => {
  e.preventDefault();
  setFormState({ ...formState, loading: true });
  try {
    await generateParagraph({
      variables: {
        input: {
          count: formState.count,
          title: formState?.selectedTitle,
        },
      },
      onCompleted: ({ generateParagraph }) => {
        const updatedParagraphs = isRegenerate ? generateParagraph : [...paragraph, ...generateParagraph];
        setParagraph(updatedParagraphs);
        setFormState({ ...formState, loading: false, selectedParagraph: "", isCheckedParagraph: true });
        setActiveStep(2);
        !isRegenerate && navigateToBlog(type, { updatedParagraphs, title: titles }, formState, navigate);
      },
      onError: errdata => {
        handleOpen(true, errdata.message);
      },
    });
  } catch (e) {
    console.log("error", e);
    setFormState({ ...formState, loading: false });
  }
};

export const handleHeadingGenerate = async ({
  e,
  formState,
  isRegenerate,
  setFormState,
  generateHeading,
  heading,
  setHeading,
  setActiveStep,
  navigate,
  handleOpen,
  paragraph,
  type,
  title,
}) => {
  e.preventDefault();
  setFormState({ ...formState, loading: true });
  try {
    await generateHeading({
      variables: {
        input: {
          count: formState.count,
          title: formState.selectedTitle,
        },
      },
      onCompleted: ({ generateHeading }) => {
        const updatedHeadings = isRegenerate ? generateHeading?.heading_sets : [...heading, ...generateHeading.heading_sets];
        setHeading(updatedHeadings);
        setFormState({ ...formState, loading: false });
        setActiveStep(3);
        !isRegenerate && navigateToBlog(type, { updatedHeadings, updatedParagraphs: paragraph, title: title }, formState, navigate);
      },
      onError: errdata => {
        console.log(errdata);
        handleOpen(true, errdata.message);
      },
    });
  } catch (e) {
    console.log("error", e);
    setFormState({ ...formState, loading: false });
  }
};

export const navigateToBlog = (type, data, formState, navigate) => {
  const paths = {
    title: "/blog-titles",
    paragraph: "/blog-paragraphs",
    heading: "/blog-headings",
    blog: "/edit-blog",
  };
  const states = {
    title: {
      title: data,
      formsState: formState,
      activeSteps: 1,
    },
    paragraph: {
      paragraphs: data?.updatedParagraphs,
      title: data.title,
      formsState: formState,
      activeSteps: 2,
    },
    heading: {
      heading: data?.updatedHeadings,
      paragraphs: data?.updatedParagraphs,
      title: data?.title,
      formsState: formState,
      activeSteps: 3,
    },
    blog: {
      blog: data,
      formsState: formState,
    },
  };

  const state = states[type];
  const pathname = paths[type];
  navigate(pathname, { state });
};

export const highlightKeyword = (text, keyword) => {
  if (!keyword) return text;
  const regex = new RegExp(`(${keyword})`, "gi");
  return text.split(regex).map((part, index) =>
    regex.test(part) ? (
      <span key={index} style={{ backgroundColor: "yellow" }}>
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export const buildOutlineFromArticleHtml = html => {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const headings = doc.querySelectorAll("h1,h2,h3,h4,h5,h6");
  let outlineHtml = "";

  headings.forEach(h => {
    outlineHtml += `
      <${h.tagName.toLowerCase()}>
        ${h.textContent.trim()}
      </${h.tagName.toLowerCase()}>
      <br/>  <!-- 👈 adds spacing -->
    `;
  });

  return outlineHtml;
};
